import api from './client';

export const getConsultorioBranding = () => api.get('/consultorio/branding');

export const uploadConsultorioLogo = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return api.post('/consultorio/branding/logo', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const removeConsultorioLogo = () => api.delete('/consultorio/branding/logo');
